import { Button, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { MdOutlineStorefront } from 'react-icons/md';

export const RootStyled = styled('div')(({ theme }) => ({
  padding: theme.spacing(8),
  minHeight: '100%',
  marginTop: -60,
}));

export const MiddleOfThePageStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-end',
  justifyContent: 'flex-end',
  gap: '32px',
  width: '100%',
  marginTop: 30,
  marginBottom: 40,
  '& .typography': {
    color: theme.palette.global.gray,
  },
}));

export const BtnStyled = styled(Button)(({ theme }) => ({
  color: theme.palette.global.white,
  fontFamily: theme.typography.button,
  height: 38,
  width: 200,
  fontSize: '11px',
  fontWeight: 'bold',
}));

export const SearchAndFilterStyled = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '42px',
  height: '35px',
});

export const SearchStyled = styled('div')({
  display: 'flex',
  borderRadius: '5px',
  height: '38px',
  width: '480px',
  backgroundColor: '#f2f2f2',
  right: '10px',
  textAlign: 'center',
  border: '1px solid #cccccccc',
});

export const TextFieldStyled = styled('input')({
  width: '500px',
  height: '35px',
  border: 'none',
  padding: '0 14px',
  fontSize: '16px',
  fontFamily: 'montserrat',
  backgroundColor: '#F2F2F2',
  outline: 'none',
});

export const ButtonInputStyled = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.global.white,
  height: '35px',
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.9),
  },
}));

export const ContentStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});

export const BackgroundIconStyled = styled('div')({
  height: '60vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});

export const IconStyled = styled(MdOutlineStorefront)(({ theme }) => ({
  color: alpha(theme.palette.global.gray, 0.2),
}));

export const TextStyled = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.h5,
  color: theme.palette.global.gray,
  fontWeight: 400,
  fontSize: 15,
}));
